import { DefaultTheme } from 'styled-components'

export const IndependentTheme: DefaultTheme = {
  colors: {
    primary: '#c3002f',
    tableStriped: '#e9e9e9',
    tableBorder: '#dee2e6',
    footer: '#232323',
    primaryDarken: '#0e233e',
    secondary: '#E3E4E5',
    linkColor: '#4270d2',
    linkColorLight: '#0083c6',
    inputBorder: '#d4d4d4',
    fontColor: '#5b5b5b',
    inputBackgroundColor: '#ffffff',
    mobileMenuBackground: '#f4f4f4',
    sectionContentBackgroundColor: '#f6f6f6',
    borderInput: '1px solid #d4d4d4',
    infoColor: '#6a8c9c',
    successColor: '#26ad77',
    warningColor: '#f90',
    dangerColor: '#b11926',
    ribbonInfoBackgroundColor: '#dae2e6',
    ribbonSuccessBackgroundColor: '#c9eadd',
    ribbonWarningBackgroundColor: '#ffe5bf',
    ribbonDangerBackgroundColor: '#ebc5c9',
    backgroundText: 'white',
    colorTextModal: '#f2dede',
    colorButtonDisabled: '#444',
    switchBackgroundColor: '#6f6f6f',
    headerFontColor: '#494949',
    defaultDealerDeactive: '#A94442',
    incentiveHeaderColor: '#3d6a3c',
    dropdownHoverColor: '#deebff',
    incentiveHeaderHoverColor: '#39a937',
    modalHeader: '#818181',
    carfaxBackground: '#3777bc',
    goodTireColor: '#406a3b',
    normalTireColor: '#e3c35e',
    badTireColor: '#ba0000',
    issueColor: '#b11926',
    defaultTextColor: '#000000',
    stickyTextColor: '#ffffff',
    darkGrayColor: '#606060',
    shadeGrayColor: '#333333',
    hoverConfirmButtonColor: '#a50129',

    //Cancel button colors
    cancelButtonBackgroundColor: '#ffffff',
    cancelButtonColor: '#000000',
    cancelButtonHoverBackgroundColor: '#000000',

    //Home Section Header
    homeSectionBackgroundColor: '#ffffff',
    homeSectionBorderColor: '#000000',
    homeSectionColor: '#000000',

    InfinitiOnlyColor: '#c3002f',

    hyperLinkColor: 'rgb(195, 0, 47)',
    hyperLinkHoverColor: 'rgb(165, 1, 41)',
    stepperCompleteColor: '#e18097',

    InfinitiLinkColor: '#c3002f',
    InfinitiLinkHoverColor: '#a50129'
  },
  headerSticky: {
    text: '#000000',
    textHover: '#5b5b5b',
    backgroundColor: '#ffffff',
    spanUnderline: '#c3002f',
    subMenuBackground: '#ffffff',
    subMenuItemBorder: '#c3002f',
    subMenuItemHover: '#c3002f',
    userMenuFont: '#000000'
  },
  headerNotSticky: {
    text: '#000000',
    textHover: '#5b5b5b',
    spanUnderline: '#c3002f',
    subMenuBackground: '#ffffff',
    subMenuItemBorder: '#000000',
    subMenuItemHover: '#000000',
    userMenuFont: '#000000'
  },
  carousel: {
    buttonBackground: '#000000',
    buttonColor: '#ffffff',
    buttonBorder: '#000000',
    buttonHoverBackground: '#333333',
    buttonHoverBorderColor: '#000000'
  },
  footer: {
    backgroundColor: '#e5e5e5',
    fontColor: '#999'
  },
  logo: {
    left: 'vendor-main-logo.png',
    right: 'site_title-new.png?version=2'
  },
  fonts: {
    fontBase: 'Nissan Brand',
    fontRegular: 'Nissan Brand'
  }
}
